import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

export const errMsg = (e, fallback = "Qualcosa è andato storto. Riprova tra poco.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Controlla i dati inseriti e riprova.";
  return fallback;
};

export const formatDate = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" });
};
